/* global suppliersIndexUrl suppliersStoreUrl suppliersCreateUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SuppliersCreateForm from './SuppliersCreateForm';

export default function SuppliersCreate() {
    return <SuppliersCreateForm suppliersIndexUrl={suppliersIndexUrl} suppliersStoreUrl={suppliersStoreUrl} suppliersCreateUrl={suppliersCreateUrl} />;
}

if (document.getElementById('SuppliersCreate')) {
    var rootEl = document.getElementById('SuppliersCreate');
    ReactDOM.render(
        <App>
            <SuppliersCreate />
        </App>,
        rootEl,
    );
}
